export function Logo({ className }: { className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="72"
      height="28"
      viewBox="0 0 72 28"
      fill="none"
      className={className}
    >
      <g clipPath="url(#clip0_21018_28295)">
        <path
          d="M18.1599 6.72062C15.5168 6.72062 13.4784 7.5997 12.1175 9.31892V7.25253H8.11346V26.6275H12.1512V16.5817C12.1512 12.5331 13.9823 10.3941 17.4433 10.3941C20.4392 10.3941 22.024 12.0405 22.024 15.1539V26.6221H26.0617V14.6163C26.0617 9.66609 23.1049 6.70947 18.1544 6.70947L18.1601 6.72062H18.1599Z"
          fill="black"
        />
        <path
          d="M34.1596 7.25781H30.1219V26.6328H34.1596V7.25781Z"
          fill="black"
        />
        <path
          d="M4.28933 7.25781H0.251648V26.6328H4.28933V7.25781Z"
          fill="black"
        />
        <path d="M4.54729 0.320068H0V4.57026H4.54729V0.320068Z" fill="black" />
        <path
          d="M34.4178 0.320068H29.8705V4.57026H34.4178V0.320068Z"
          fill="black"
        />
        <path
          d="M44.8278 2.2627H40.7901V7.25752H36.5117V10.9365H40.7901V20.8647C40.7901 24.6894 42.7277 26.6268 46.5525 26.6268H50.1757V22.9479H44.9454C44.8838 22.9479 44.8612 22.9422 44.8612 22.9422L44.8278 22.9142C44.8278 22.9142 44.8221 22.8974 44.8221 22.8303V10.9367H50.1702V7.25773H44.8221V2.2627H44.8278Z"
          fill="black"
        />
        <path
          d="M61.7743 6.71997C56.1295 6.71997 51.5488 11.2948 51.5488 16.9451C51.5488 22.5953 56.1238 27.1701 61.7743 27.1701C67.4247 27.1701 72 22.5951 72 16.9451C72 11.295 67.4247 6.71997 61.7743 6.71997ZM67.5198 22.6847H56.0342V11.1997H67.5198V22.6847Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_21018_28295">
          <rect
            width="72"
            height="27.36"
            fill="white"
            transform="translate(0 0.320068)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
